import { Dimensions } from 'react-native'

import { i18n } from '@zet/localization'
import CreditCrad from '@zet/svg/addCustomer/creditCard'
import CreditCradActive from '@zet/svg/addCustomer/creditCardActive'
import Loans from '@zet/svg/addCustomer/loans'
import LoansActive from '@zet/svg/addCustomer/loansActive'
import moment from 'moment'

export const DEVICE_WIDTH = Dimensions.get('window').width
export const DEVICE_HEIGHT = Dimensions.get('window').height

// ✅ Use export enum (not const enum, not export const enum)
export enum LeadStatus {
  LEAD_ADDED = 'leadadded',
  ACTION_REQUIRED = 'actnreqrd',
  PARTIALLY_FULLFILLED = 'pfulfilled',
  FULLFILLED = 'fullfilled',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  INCOMPLETE = 'saleIncomplete',
}

export enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  REJECTED = 'rejected',
  FAILED = 'failed',
  LOCKED = 'locked',
  EXPIRED = 'expired',
}

export enum PayoutType {
  DEMO = 'demo_payout',
}

export const PaymentCardStatus = Object.freeze([
  'pending',
  'paid',
  'rejected',
  'failed',
  'locked',
  'expired',
])

export enum Categories {
  CREDIT_CARDS = 15,
  PERSONAL_LOANS = 9,
  PAY_LATER_EMI_CARDS = 16,
  BUSINESS_LOANS = 10,
  INSURANCE = 14,
  BANK_ACCOUNTS = 5,
  DEMAT_ACCOUNTS = 6,
  SECURED_CREDIT_CARDS = 18,
  OTHER_LOANS = 23,
  HOME_LOANS = 24,
  CIBIL_BUILDER_LOANS = 25,
  FIXED_DEPOSIT = 19,
  DIGITAL_GOLD = 2,
  GOLD_LOAN = 12,
  INSTANT_LOANS = 11,
  TWO_WHEELER_LOANS = 22,
  OTHER = 20,
  // ⚠️ Duplicate value with SECURED_CREDIT_CARDS
  SBM = 18,
  ZET_STORE = 26,
  CARS24 = 27,
  INVESTMENTS = 7,
}

export const QuickFilter = {
  stage: { name: 'stage', value: [] },
  brands: { name: 'partner', value: [] as string[] },
  profileStatus: { name: 'status', value: [] as string[] },
  category: { name: 'category', value: [] as string[] },
}

export const playstoreRedirection =
  'http://play.google.com/store/apps/details?id=in.onecode.app'

export const appstoreRedirection =
  'https://apps.apple.com/in/app/zet-partner-earn-extra-income/id6753862458'

export const appVideos = {
  zetMyNetwork: { title: ' ', videoId: 'lO9Lr9rIZRU' },
  zetMyTeam: { title: ' ', videoId: 'CRsrSxdWLjg' },
  zetMyCustomers: { title: ' ', videoId: 'CRsrSxdWLjg' },
  zetWhyPan: { title: ' ', videoId: 'Q5PmwtJLUrs' },
  zetWhyOtp: { title: ' ', videoId: 'CRsrSxdWLjg' },
  zetHowToEarn: { title: ' ', videoId: 'MftwPtsOg4k' },
  zetPlaceHolder: { title: ' ', videoId: 'CRsrSxdWLjg' },
  zetCreditScore: { title: ' ', videoId: 'uCq0WNrsjI8' },
  zetAgentWebsite: { title: ' ', videoId: 's7C5fslrxO4' },
}

export const Months = [
  { label: 'January', key: 0, value: 'january' },
  { label: 'February', key: 1, value: 'february' },
  { label: 'March', key: 2, value: 'march' },
  { label: 'April', key: 3, value: 'april' },
  { label: 'May', key: 4, value: 'may' },
  { label: 'June', key: 5, value: 'june' },
  { label: 'July', key: 6, value: 'july' },
  { label: 'August', key: 7, value: 'august' },
  { label: 'September', key: 8, value: 'september' },
  { label: 'October', key: 9, value: 'october' },
  { label: 'November', key: 10, value: 'november' },
  { label: 'December', key: 11, value: 'december' },
]

export const rejectionPayoutCategoryList = ['9', '15', '10', '11', 'all']
export const loansCategoriesEmiCalculator = ['11', '9', '10', '12']

export const filterData = [
  { icon: '', text: 'ZET Id', key: 'ZET_ID' },
  { icon: '', text: 'Phone Number', key: 'PHONE_NUMBER' },
  { icon: '', text: 'Name', key: 'NAME' },
]

export const sortingOptionsForVerified = [
  { label: i18n.t('myCustomers.byCreditScore'), value: 'creditReport' },
  { label: i18n.t('myCustomers.byName'), value: 'name' },
  { label: i18n.t('myCustomers.byAdditonDate'), value: 'createdAt' },
]

export const sortingOptionsForNonVerified = [
  { label: i18n.t('myCustomers.byAdditonDate'), value: 'createdAt' },
  { label: i18n.t('myCustomers.byName'), value: 'name' },
]

export const bannerLogic = {
  COLLAPSIBLE_ON_CLICK: 'COLLAPSIBLE_ON_CLICK',
}

export enum HDFC_ASKCODES {
  $ARN_REQUIRED = '$ARN_REQUIRED',
  $ARN_PENDING = '$ARN_PENDING',
  $ARN_INCORRECT = '$ARN_INCORRECT',
}

export enum HelpAndSupportType {
  RAISE_A_COMPLAINT = 'raiseAComplaint',
  CHAT_WITH_US = 'chatWithUs',
  CALL_US = 'callUs',
  FAQS = 'faqs',
  APP_FEEDBACK = 'appImprovement',
}

// ✅ Keep component reference instead of JSX
export const customerInterestList = [
  {
    id: 'CC',
    title: i18n.t('customerInterest.creditCard'),
    isActive: true,
    activeIcon: CreditCradActive,
    inActiveIcon: CreditCrad,
  },
  {
    id: 'LOANS',
    title: i18n.t('customerInterest.loan'),
    isActive: false,
    activeIcon: LoansActive,
    inActiveIcon: Loans,
  },
]

export const LOANS_CATEGORY = [9, 10, 12]

export const INTENT = {
  HIGH: 'HIGH',
  LOW: 'LOW',
}

export const USER_PROFILE_TYPE = {
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  COMPLETED: 'COMPLETED',
  GUEST: 'GUEST',
}

export const BUTTON_TYPE = {
  PRESSABLE: 'PRESSABLE',
  BUTTON: 'BUTTON',
  TILE_TAG: 'TILE_TAG',
}

export const DYNAMIC_REJECTION_PAYOUT = 'upto ₹100'
export const REJECTION_PAYOUT = '₹25'
export const PLACE_HOLDER_PHONE_NUMBER = '900 000 0000'

export const INTENT_MAPPING = {
  StartSelling: INTENT.HIGH,
  SellCreditCards: INTENT.HIGH,
  EarningCardAction: INTENT.HIGH,
  AddCustomer: INTENT.HIGH,
  SellNow: INTENT.HIGH,
  UserProfile: INTENT.LOW,
  TotalEarnings: INTENT.LOW,
  LoyaltyCard: INTENT.LOW,
  CreditScoreCheck: INTENT.LOW,
  BrandTraining: INTENT.LOW,
  MyIdCard: INTENT.LOW,
  MyVisitingCard: INTENT.LOW,
  OfferLetter: INTENT.LOW,
  CreditScore: INTENT.LOW,
  MyTeams: INTENT.LOW,
  LeadSummary: INTENT.LOW,
  MarketingResource: INTENT.LOW,
  ApplicationProcessShare: INTENT.LOW,
  Network: INTENT.LOW,
  ZetCoins: INTENT.LOW,
  EarningsCard: INTENT.LOW,
  FooterIcons: INTENT.LOW,
  Notification: INTENT.LOW,
  BankError: INTENT.LOW,
  PreRecordedTraining: INTENT.LOW,
  Leads: INTENT.LOW,
  BestOffers: INTENT.LOW,
}

export enum ContestCardTypes {
  PARTICIPATE_DETAILS = 'participate_details',
  PRIZE_DETAILS = 'prize_details',
  DURATION_DETAILS = 'duration_details',
  FAQS = 'faqs',
  CUSTOMER_BENEFITS = 'customer_benefits',
  TABLE = 'table',
  CAMPAIGN_BENEFITS = 'campaign_benefits',
}

export const earningsFilter = [
  { filterName: 'Date', leftIcon: 'DayOutlined', rightIcon: 'ArrowDown' },
  { filterName: 'Status', leftIcon: 'GroupOutlined', rightIcon: 'ArrowDown' },
  { filterName: 'Brand', leftIcon: 'TagOutlined', rightIcon: 'ArrowDown' },
]

export const timeFilterOptions = [
  {
    name: 'This Week',
    startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
  },
  {
    name: 'Last Week',
    startDate: moment()
      .subtract(1, 'weeks')
      .startOf('isoWeek')
      .format('YYYY-MM-DD'),
    endDate: moment()
      .subtract(1, 'weeks')
      .endOf('isoWeek')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'This Month',
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD'),
  },
  {
    name: 'Last Month',
    startDate: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    endDate: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
  },
]

export const TRAINING_STATUS = Object.freeze({
  REGISTERED: 'REGISTERED',
  UNREGISTERED: 'UNREGISTERED',
})

export const zetStoreDpandaIds = Object.freeze({
  partnerId: 668,
  variantId: 769,
})

export const MAGNET_BRAND_ID = Object.freeze({
  partnerId: 193,
  variantId: 271,
})
